import VueCookie from 'vue-cookie';
import Router from '../router/index.js';
import Axios from 'axios'

const Projects = {
  state: {
    projects: null,
    project: null,
  },
  getters: {
    get_projects: (state) => {
      return state.projects
    },
    get_project: (state) => {
      return state.project
    },
    get_firstKey: (state) => {
      return state.project ? state.project.project.apis[0].keys[0].key : null;
    }
  },
  mutations: {
    set_projects: (state, payload) => {
      state.projects = payload;
    },
    set_project: (state, payload) => {
      state.project = payload;
    }
  },
  actions: {
    api_index: (context, payload) => {
      if(!context.state.projects || payload){
        Axios.get(process.env.VUE_APP_JOAT_URL + '/projects', {headers:{
            Authorization: "Bearer " + VueCookie.get('access_token')
          }})
          .then(response => {
            context.commit('set_projects', response.data)
          })
          .catch(error => {
            alert(error)
          })
      }

    },
    api_create: (context, payload) => {
      Axios.post(process.env.VUE_APP_JOAT_URL + '/projects', {
        name: payload.name,
      }, {headers:{
          Authorization: "Bearer " + VueCookie.get('access_token')
        }})
        .then(response => {
          context.dispatch('api_index', true);
        })
        .catch(error => {
          alert(error)
        })
    },
    selectProject: (context, payload) => {
      Axios.get(process.env.VUE_APP_JOAT_URL + '/projects/' + payload, {headers: {
          Authorization: "Bearer " + VueCookie.get('access_token')
        }})
        .then(response => {
          context.commit('set_project', response.data)
        })
        .catch(error => {
          alert(error)
        })
    },
  },
  namespaced: true
}
export default Projects;
